import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X, GraduationCap, LogOut, LayoutDashboard, Shield } from "lucide-react";

export default function Navbar({ transparent = false }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  const bgClass = transparent
    ? "fixed top-0 w-full z-50 backdrop-blur-xl bg-white/80 border-b border-slate-200/50 transition-all"
    : "sticky top-0 w-full z-50 bg-white border-b border-slate-200 shadow-sm";

  return (
    <nav className={bgClass} data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_examen-prep-mx/artifacts/0mkzmukl_Logo%20Mi%20Prepa%20en%20Shorts.jpeg"
              alt="Mi Prepa en Shorts"
              className="h-10 w-10 rounded-full object-cover"
            />
            <span className="font-bold text-lg text-[#193B6E]" style={{ fontFamily: 'Outfit' }}>
              Mi Prepa en Shorts
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/free" className="text-[#193B6E] font-medium hover:text-[#20D3C0] transition-colors" data-testid="nav-free">
              Contenido Gratis
            </Link>
            {user ? (
              <>
                <Link to="/dashboard" className="text-[#193B6E] font-medium hover:text-[#20D3C0] transition-colors" data-testid="nav-dashboard">
                  Mi Panel
                </Link>
                <Link to="/events" className="text-[#193B6E] font-medium hover:text-[#20D3C0] transition-colors" data-testid="nav-events">
                  Eventos
                </Link>
                {user.role === "admin" && (
                  <Link to="/admin" className="text-[#193B6E] font-medium hover:text-[#20D3C0] transition-colors flex items-center gap-1" data-testid="nav-admin">
                    <Shield className="w-4 h-4" /> Admin
                  </Link>
                )}
                <button
                  onClick={handleLogout}
                  className="text-[#193B6E] font-medium hover:text-red-500 transition-colors flex items-center gap-1"
                  data-testid="nav-logout"
                >
                  <LogOut className="w-4 h-4" /> Salir
                </button>
              </>
            ) : (
              <Link
                to="/auth"
                className="bg-[#20D3C0] text-[#112C54] hover:bg-[#1AB8A6] font-semibold rounded-full px-6 py-2 transition-all hover:-translate-y-0.5 shadow-md"
                data-testid="nav-login"
              >
                Iniciar Sesion
              </Link>
            )}
          </div>

          {/* Mobile Toggle */}
          <button
            className="md:hidden text-[#193B6E]"
            onClick={() => setMobileOpen(!mobileOpen)}
            data-testid="mobile-menu-toggle"
          >
            {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-slate-200 pt-4 space-y-3 animate-fade-in">
            <Link to="/free" className="block text-[#193B6E] font-medium py-2" onClick={() => setMobileOpen(false)}>
              Contenido Gratis
            </Link>
            {user ? (
              <>
                <Link to="/dashboard" className="block text-[#193B6E] font-medium py-2" onClick={() => setMobileOpen(false)}>
                  Mi Panel
                </Link>
                <Link to="/events" className="block text-[#193B6E] font-medium py-2" onClick={() => setMobileOpen(false)}>
                  Eventos
                </Link>
                {user.role === "admin" && (
                  <Link to="/admin" className="block text-[#193B6E] font-medium py-2" onClick={() => setMobileOpen(false)}>
                    Admin
                  </Link>
                )}
                <button onClick={handleLogout} className="block text-red-500 font-medium py-2">
                  Salir
                </button>
              </>
            ) : (
              <Link to="/auth" className="block bg-[#20D3C0] text-[#112C54] font-semibold rounded-full px-6 py-2 text-center" onClick={() => setMobileOpen(false)}>
                Iniciar Sesion
              </Link>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}
